import React, { useEffect, useState } from "react";
import DialogBox from "../../components/DialogBox";
import Text from "../../components/Text";
import Spacer from "../../components/Spacer";
import AsyncForm from "../../components/Materials/AsyncForm";
import { Field } from "redux-form";
import { confirmation, length, required } from "redux-form-validators";
import { get } from "lodash";
import { Button } from "../../components/Field";
import { showToast } from "../../helpers/notify";
import { sinceDays } from "../../helpers/date";
import { getPasswordValidationInfo, getPasswordValidationRegex, isValid } from "../../helpers/input";
import Editor from "../../components/Editor";
import Input from "../../components/Field/Input/Input";
import PasswordStrength from "../../components/Field/Password/Strength";

let timeout = null;
const ChangePassword = ({ userData, reloadUser = () => { } }) => {
    const { password_updated_at = null } = userData;
    const [popup, setPopup] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (sinceDays(password_updated_at) >= 180 || isValid(password_updated_at) === false) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPopup("change-password");
            }, 5000);
        }

        return (() => {
            clearTimeout(timeout);
        });
    }, [password_updated_at]);


    return (
        <>
            {popup === "change-password" &&
                <DialogBox
                    hasCloseIcon={false}
                    title="Change Password"
                    buttonClassName="bordereauxButton"
                    render={({ closeDialog }) => {
                        return (
                            <>
                                <AsyncForm
                                    attribute="ChangePassword"
                                    id="ChangePassword"
                                    url="/account/update-password"
                                    type="patch"
                                    hasGetAction={false}
                                    permissionText="Account Update Password"
                                    showToastOnSuccess={false}
                                    onSave={() => {
                                        closeDialog(() => {
                                            showToast("Password was changed successfully");
                                            reloadUser();
                                        })
                                        setSubmitting(false);
                                    }}
                                    onError={() => {
                                        setSubmitting(false);
                                    }}
                                    changeFormValuesBeforeSubmit={(data) => {
                                        setSubmitting(true);
                                        return data;
                                    }}
                                    render={({ formValues }) => {
                                        return (
                                            <div>
                                                <Text>You must update your password, as it was last changed more than 180 days ago.</Text>
                                                <Spacer />
                                                <Editor text={`<p>${getPasswordValidationInfo()}</p>`} />
                                                <Spacer />
                                                <Field name="password_old" type="password" component={Input} validate={[required()]} label="Old Password" required={true} />
                                                <Spacer />
                                                <Field name="password" type="password" component={Input} validate={[required(), length({ minimum: 8 }), getPasswordValidationRegex()]} label="New Password" required={true} />
                                                <Spacer />
                                                <Field name="confirm_password" type="password" component={Input} validate={[required(), confirmation({ field: 'password' })]} label="Confirm Password" required={true} />
                                                <PasswordStrength password={get(formValues, 'password')} />
                                            </div>
                                        )
                                    }}
                                />
                            </>
                        )
                    }}
                    buttons={() => {
                        return (
                            <>
                                <Button label="Change" submit={true} fetching={submitting} form="ChangePassword" />
                            </>
                        )
                    }}
                />
            }
        </>
    )
}

export default ChangePassword;